const messages = {
  overview: {
    period: 'Periodo',
    monthsCurrent: 'Mes actual',
    monthsLast: 'Mes pasado',
    months3: '3 meses',
    months6: '6 meses',
    months12: '12 meses',
    deltaFlat: '▬ sin cambios',
    deltaVsPrev: 'vs. periodo anterior',
    kpiCredits: 'Creditos consumidos',
    kpiMessages: 'Mensajes',
    kpiAvgPerMsg: 'Creditos / mensaje',
    kpiCostCenters: 'Centros de coste activos',
    chartTitle: 'Creditos por mes y canal',
    chartSubtitle: 'Apilado por canal',
    credits: 'creditos',
    messages: 'mensajes',
    byChannelTitle: 'Por canal',
    byChannelSubtitle: 'Creditos y mensajes del periodo',
    topCentersTitle: 'Top centros de coste',
    topCentersSubtitle: 'Por creditos consumidos en el periodo',
    colChannel: 'Canal',
    colMessages: 'Mensajes',
    colCredits: 'Creditos',
    colAvg: 'Creditos/msg',
    colCostCenter: 'Centro de coste',
    colShare: 'Cuota',
  },
  name: 'Resumen de Eventos de Credito |||| Resumenes de Eventos de Credito',
  fields: {
    costCenterName: 'Centro de Coste',
    applicationName: 'Aplicacion',
    channel: 'Canal',
    year: 'Ano',
    month: 'Mes',
    totalMessages: 'Total de Mensajes',
    totalCreditsConsumed: 'Total de Creditos Consumidos',
    createdAt: 'Fecha de Creacion',
  },
  empty: 'No hay resumenes de eventos',
  filters: {
    costCenterName: 'Centro de Coste',
    applicationName: 'Aplicacion',
    channel: 'Canal',
  },
  search: {
    placeholder: 'Buscar Resumen de Creditos',
  },
  trendsTitle: 'Uso de Creditos y Mensajes por Canal por Centro de Coste + Aplicacion',
  trendsXAxisLabel: 'Centro de Coste - Aplicacion',
  trendsYAxisLabel: 'Total',
  trendsEmpty: 'No hay datos de tendencia disponibles',
  trendsFailed: 'Error al cargar los datos de tendencia',
};

export default messages;
